import { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import CardDeals from '../components/CardDeals';
import './Fidelite.css';

const Fidelite = () => {
  const [offres, setOffres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOffres = async () => {
    try {
      const q = query(
        collection(db, 'fidelite'),
        orderBy('order', 'asc')
      );
      const querySnapshot = await getDocs(q);
      const offresData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setOffres(offresData);
      setLoading(false);
    } catch (error) {
      console.error("Erreur lors de la récupération des offres fidélité:", error);
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffres();
  }, []);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>Une erreur est survenue...</div>;

  return (
    <div className="fidelite-page">
      <div className="fidelite-info-icon" tabIndex="0" aria-label="À propos des offres fidélité">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="#83040c" opacity="0.12"/>
          <path d="M12 8.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm-1 2.75a1 1 0 112 0v4a1 1 0 11-2 0v-4z" fill="#83040c"/>
        </svg>
        <span className="fidelite-info-tooltip">
          Offres permanentes réservées à nos clients fidèles, valables toute l'année sans interruption.
        </span>
      </div>
      <CardDeals deals={offres} />
    </div>
  );
};

export default Fidelite; 